module.exports = __webpack_public_path__ + "img/w-phone.b47c05a0.png";